import OnHoldNotifications from './OnHoldNotifications';

export default OnHoldNotifications;
